import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import borderFooter from 'resources/svg/footer-border.svg'
import footerShape from 'resources/svg/footer-shape.svg'
import { containerWide, link } from 'app/sofia/resources/theme/css'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Container = styled.div`
  background: ${props => props.theme.palette.general.greyLighter};
  border-top: 1px solid ${props => props.theme.palette.general.soft};
  padding: 40px 0;
  position: relative;
  z-index: 2;
  font: ${font('default', 'light', '16px/1')};

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 200px;
    background: url(${borderFooter});
    position: absolute;
    z-index: -1;
    top: -20px;
    background-repeat-y: no-repeat;
  }

  &::after {
    content: '';
    display: block;
    width: 280px;
    height: 240px;
    background: url(${footerShape});
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -1;
  }

  > div {
    ${containerWide}
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media (max-width: ${BREAKPOINT.LG}) {
      padding: 0 40px;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  a {
    ${link}
    color: ${props => props.theme.palette.general.strong};
    text-decoration: none;
  }

  h2 {
    font: ${font('alt', 'normal', '20px/1')};
  }

  .footer__main-column {
    width: 55%;
    display: flex;
    justify-content: space-evenly;
    flex-grow: 1;
    padding: 0 10px;
    box-sizing: border-box;

    > div {
      margin: 0 15px;
    }

    @media (max-width: ${BREAKPOINT.LG}) {
      width: 75%;
    }

    @media (max-width: ${BREAKPOINT.MD}) {
      width: 100%;
      justify-content: space-between;
    }

    ${bp('sm')`
      flex-direction: column;
    `}
  }
`

export const FooterLogo = styled.div`
  @media (max-width: ${BREAKPOINT.MD}) {
    order: 4;
    width: 50%;
    text-align: right;
  }

  ${bp('sm')`
    order: 0;
    width: 100%;
    text-align: left;
    margin: 30px 0;
  `}
`
